import styled from 'styled-components'

const HorseInfoContainer = styled.div`
  .loading {
    height: 200px;
    margin: 0 auto;
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .head {
    width: 575px;
    height: 50px;
    background: linear-gradient(
      90deg,
      rgba(18, 21, 32, 0) 0%,
      rgba(78, 242, 125, 0.4) 51.04%,
      rgba(18, 22, 33, 0) 100%
    );
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-bottom: 50px;
    margin-top: 20px;

    img {
      width: 45px;
      height: 45px;
      border-radius: 50%;
    }

    span {
      color: white;
      font-size: 20px;
      display: inline-block;
      padding: 0 3px;

      &:first-child {
        padding-left: 20px;
      }
    }
  }

  .content-horse {
    margin: 0 auto;
    width: 1240px;
    min-height: 240px;
    border: 1px solid #47F0B1;
    position: relative;
    background: linear-gradient(180deg, rgba(19, 2, 41, 0) 0%, #252B43 100%);
    padding: 20px;
    display: grid;
    grid-template-columns: 24.5rem 15.5rem 14rem auto;

    .line-1 {
      position: absolute;
      bottom: -11px;
      left: 0;
    }
    .line-2 {
      position: absolute;
      bottom: -11px;
      right: 0;
    }
  }
`

export default HorseInfoContainer
